const getters = {
  // 是否是VIP
  isVIP (state) {
    return Number(state.applyStatusInfo.status) === 8 && (
      Number(state.applyStatusInfo.explanation) === 1 || Number(state.applyStatusInfo.explanation) === -3
    )
  },

  // 仅参加过活动的非会员
  isOnlyApplyMember (state) {
    return state.baseInfo.user_status === -4
  },

  // 是否是员工
  isAdmin (state) {
    return state.baseInfo.admin
  },

  // 是否展示 VIP 部分
  showVIPSections (state, getters) {
    return state.isLogin && (getters.isVIP || getters.isAdmin)
  }
}

export default getters
